import { render, staticRenderFns } from "./dialog-area.vue?vue&type=template&id=65095106&scoped=true"
import script from "./dialog-area.vue?vue&type=script&lang=js"
export * from "./dialog-area.vue?vue&type=script&lang=js"
import style0 from "./dialog-area.vue?vue&type=style&index=0&id=65095106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65095106",
  null
  
)

export default component.exports